import { ProductCombinationInterface, ProductVariantSizeColorInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';

export function getDefaultVariantOption(
  combinations: ProductCombinationInterface[] | null,
): ProductVariantSizeColorInterface | null {
  if (!combinations || isEmpty(combinations)) return null;

  const defaultCombination = combinations.find((c) => c.availableForSale && c.inventoryQuantity > 0) || combinations[0];

  if (!defaultCombination) return null;

  const selectedOptions = {} as ProductVariantSizeColorInterface;

  for (const option of defaultCombination.options || []) {
    selectedOptions[option.name.toLowerCase()] = option.value as string;
  }

  // Ensure there's at least one valid option
  if (isEmpty(selectedOptions)) {
    return null;
  }

  return selectedOptions;
}
